const ptTranslation = () => {
    return {
        common: {
            edit: 'Editar',
            create: 'Criar',
            save: 'Salvar',
            update: 'Atualizar',
            saving: 'Salvando...',
            cancel: 'Cancelar',
            delete: 'Excluir',
            search: 'Pesquisar',
            title: 'Título',
            description: 'Descrição',
            intensity: 'Intensidade',
            areYouSure: 'Tem certeza?',
            none: 'Nenhum',
            all: 'Todos',
            sessionExpired: 'Sua sessão expirou',
            errorOccurred: 'Ocorreu um erro',
            success: 'Sucesso',
            error: 'Erro',
            warning: 'Aviso',
            info: 'Informação',
            confirm: 'Confirmar',
            back: 'Voltar',
            next: 'Próximo',
            previous: 'Anterior',
            loading: 'Carregando...',
            noData: 'Nenhum dado disponível',
            actions: 'Ações',
            close: 'Fechar',
            submit: 'Enviar',
            reset: 'Redefinir',
            requiredField: 'Este campo é obrigatório',
            invalidEmail: 'E-mail inválido',
            invalidPhone: 'Número de telefone inválido',
            invalidUrl: 'URL inválida',
            invalidDate: 'Data inválida',
            invalidTime: 'Hora inválida',
            invalidDatetime: 'Data e hora inválidas',
            invalidNumber: 'Número inválido',
            invalidInteger: 'Número inteiro inválido',
            invalidDecimal: 'Número decimal inválido',
            invalidPassword: 'Senha inválida',
            invalidConfirmPassword: 'As senhas não conferem',
            invalidMinLength: 'Deve ter pelo menos {min} caracteres',
            invalidMaxLength: 'Não deve exceder {max} caracteres',
            active: 'Ativo',
            status: 'Status',
            showCompleted: 'Mostrar concluídos',
            completed: 'Concluído',
        },
        faq: {
            title: 'Perguntas Frequentes',
            noFaq: 'Nenhuma pergunta frequente disponível no momento.',
            deleteSuccess: 'A pergunta foi excluída com sucesso',
            deleteError: 'Ocorreu um erro ao excluir a pergunta',
            updateSuccess: 'A pergunta foi atualizada com sucesso',
            manage: 'Gerenciamento de Perguntas Frequentes',
            edit: 'Editar pergunta',
            create: 'Criar pergunta',
            createSuccess: 'Pergunta criada com sucesso',
            categories: {
                all: 'Todas as categorias',
                general: 'Geral',
                account: 'Conta',
                subscription: 'Assinatura',
                payment: 'Pagamento',
                other: 'Outro',
            },
            form: {
                question: 'Pergunta',
                answer: 'Resposta',
                category: 'Categoria',
                order: 'Ordem de exibição',
                isActive: 'Ativo',
                newQuestion: 'Nova pergunta',
                editQuestion: 'Editar pergunta',
                createSuccess: 'Pergunta criada com sucesso',
                updateSuccess: 'Pergunta atualizada com sucesso',
                deleteSuccess: 'Pergunta excluída com sucesso',
                deleteConfirm: 'Tem certeza de que deseja excluir esta pergunta?',
                validation: {
                    questionRequired: 'A pergunta é obrigatória',
                    answerRequired: 'A resposta é obrigatória',
                    categoryRequired: 'A categoria é obrigatória',
                },
            },
            filter: {
                category: 'Filtrar por categoria',
                showInactive: 'Mostrar perguntas inativas',
                markAsComplete: 'Marcar como concluído',
                markAsIncomplete: 'Marcar como não concluído',
                inactive: 'Inativo',
                lastUpdated: 'Última atualização',
                completed: 'Concluído',
            },
            invalidMinValue: 'Deve ser maior ou igual a {min}',
            invalidMaxValue: 'Deve ser menor ou igual a {max}',
            invalidPattern: 'Formato inválido',
            invalidRequired: 'Este campo é obrigatório',
            invalidUrlFormat: 'Formato de URL inválido',
            invalidEmailFormat: 'Formato de e-mail inválido',
            invalidPhoneFormat: 'Formato de telefone inválido',
            invalidDateRange: 'A data final deve ser posterior à data inicial',
            invalidTimeRange: 'A hora final deve ser posterior à hora inicial',
            invalidDatetimeRange: 'A data e hora finais devem ser posteriores à data e hora iniciais',
        },
        global: {
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira',
            saturday: 'Sábado',
            sunday: 'Domingo',
            lang: {
                fr: 'Francês (French)',
                gb: 'Inglês (English)',
                br: 'Brasil (Brazil)',
            },
            back: 'Voltar',
        },
        home: {
            'main-title': "Badminton Villeneuve d'Ascq",
            'presentation-1': 'Jovens e Adultos, competidores e lazer, ',
            'presentation-2': ' ',
            'presentation-3': '',
            'presentation-4': ' O BVA promove a diversão para todos os jogadores de badminton.',
            'last-news': 'Últimas notícias',
        },
        header: {
            menu: {
                home: 'Início',
                planning: 'Planos e Preços',
                registration: 'Inscrever-se',
                competition: 'Torneios',
                contact: 'Fale conosco',
                faq: 'Perguntas Frequentes',
                'my-space-bva': 'Meu espaço BVA',
                login: 'Entre',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'send-email': 'Enviar',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                email: 'Endereço de email',
                'email-placeholder': 'Digite seu endereço de email',
                'pseudo-placeholder': 'Digite seu nome de usuário',
                'reset-password-email-sent': 'Um email de redefinição foi enviado',
                member: 'Membro',
                coach: 'Treinador',
                admin: 'Administrador',
                connexion: 'Conexão',
                'account-type': 'Tipo de conta',
                'select-account-type': 'Selecione um tipo de conta',
            },
            login: {
                connexion: 'Conexão',
                member: 'Membro',
                coach: 'Treinador',
                admin: 'Administrador',
                'account-type': 'Tipo de conta',
                'select-account-type': 'Selecione um tipo de conta',
                'connection-success': 'Conexão bem-sucedida',
                'go-to-member-space': 'Ir para o espaço do membro',
                'go-to-coach-space': 'Ir para o espaço do treinador',
                'go-to-admin-space': 'Ir para o espaço do administrador',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'reset-password-email-sent': 'Um email de redefinição foi enviado',
                'send-email': 'Enviar',
                pseudo: 'Nome de usuário',
                'enter-pseudo': 'Digite seu nome de usuário',
                'pseudo-placeholder': 'Seu nome de usuário',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                email: 'Endereço de email',
                'email-placeholder': 'Digite seu endereço de email',
                password: 'Senha',
                'email-label': 'Email',
                'email-or-pseudo': 'Email ou nome de usuário',
                'enter-email': 'Digite seu email',
                connect: 'Conectar',
            },
            'my-tournament-account': 'Minha conta de torneios',
            'tournament-account-message':
                'A conta de torneios começa em 0€ e pode alcançar o máximo de 25€.Ela diz respeito somente aos competidores. É fácil para aumentar os valores na sua conta: basta participar dos treinamentos e nos avisar se estiver ausente.',
        },
        footer: {
            copyright: `Copyright © ${new Date().getFullYear()}. Todos os direitos reservados - Site criado por`,
            administration: 'Administrador',
        },
        sidebar: {
            admin: {
                dashboard: 'Painel',
                user: 'Usuário',
                news: 'Notícias',
                competition: 'Torneios',
                plannings: 'Planos',
                prices: 'Taxas',
                documentation: 'Documentação',
                'bva-bot': 'BVA bot',
                'to-document-myself': 'Para me documentar',
                coachs: 'Coachs',
                faq: 'Perguntas Frequentes',
                'training-sessions': 'Sessões de Treinamento',
                trainingSessions: {
                    title: 'Minhas Sessões de Treinamento',
                    filterByIntensity: 'Filtrar por intensidade',
                    noSessions: 'Nenhuma sessão encontrada',
                    steps: 'Etapas',
                    startTime: 'Hora de início',
                    endTime: 'Hora de término',
                    createdSuccess: 'A sessão foi criada com sucesso',
                    updatedSuccess: 'A sessão foi atualizada com sucesso',
                    exercise: 'Exercício',
                    addStep: 'Adicionar etapa',
                    deleteSuccess: 'Sessão excluída com sucesso',
                    deleteError: 'Ocorreu um erro ao excluir a sessão',
                    createSuccess: 'Sessão criada com sucesso',
                    createError: 'Ocorreu um erro ao criar a sessão',
                    updateSuccess: 'Sessão atualizada com sucesso',
                    updateError: 'Ocorreu um erro ao atualizar a sessão',
                    toggleCompleteSuccess: 'Status da sessão atualizado com sucesso',
                    toggleCompleteError: 'Ocorreu um erro ao atualizar o status da sessão',
                    session: 'sessão',
                    newSession: 'Nova Sessão',
                    editSession: 'Editar Sessão',
                    viewMembers: 'Ver membros',
                    groupMembers: 'Membros do grupo',
                    sessionTitle: 'Título',
                    sessionDescription: 'Descrição',
                    sessionIntensity: 'Intensidade',
                    sessionIntensityLow: 'Baixa',
                    sessionIntensityMedium: 'Média',
                    intensityHigh: 'Alta',
                    intensityVeryHigh: 'Muito alta',
                    intensityExtreme: 'Extrema',
                    group: 'Grupo',
                    noGroup: 'Nenhum grupo',
                    groupPlaceholder: 'Selecione um grupo',
                    groupHelp: 'Opcional - Associe esta sessão a um grupo existente',
                    sessionDescriptionPlaceholder: 'Descreva o conteúdo da sessão...',
                    sessionTitlePlaceholder: 'Digite o título da sessão',
                    sessionSteps: 'Etapas da Sessão',
                    stepTitle: 'Título',
                    stepStartTime: 'Hora de início',
                    stepEndTime: 'Hora de término',
                    stepExercise: 'Exercício Associado (opcional)',
                    stepDescription: 'Descrição (opcional)',
                    noExercise: 'Nenhum exercício',
                    addStepButton: 'Adicionar uma etapa',
                    deleteStep: 'Excluir esta etapa',
                    step: 'Etapa',
                    stepNumber: 'Etapa {{number}}',
                    moveUp: 'Mover para cima',
                    moveDown: 'Mover para baixo',
                    viewExercise: 'Ver detalhes do exercício',
                    generateExercise: 'Gerar exercício',
                    loading: '...',
                    errors: {
                        titleRequired: 'O título é obrigatório',
                        stepTitleRequired: 'O título da etapa {{index}} é obrigatório',
                        invalidTimeRange: 'A hora de término deve ser posterior à hora de início (etapa {{index}})',
                        overlappingSteps: 'As etapas {{step1}} e {{step2}} se sobrepõem',
                        authRequired: 'Autenticação necessária',
                        genericError: 'Ocorreu um erro',
                        errorOccurred: 'Ocorreu um erro',
                        sessionRequired: 'Sessão necessária',
                    },
                },
            },
            member: {
                'my-progression': 'Minha progressão',
                password: 'Senha',
                'satisfaction-survey': 'Pesquisa de Satisfação',
                'satisfaction-survey-thank-you': 'Obrigado por dedicar tempo para compartilhar sua experiência conosco.',
                'satisfaction-survey-iframe-fallback': 'A pesquisa de satisfação não pode ser exibida. Por favor, clique neste link para acessá-la.',
            },
        },
        admin: {
            dashboard: 'Painel',
            or: 'ou',
            'search-member-input': '🔍 Pesquisar um membro',
            'search-coach-input': '🔍 Pesquisar um coach',
        },
        coach: {
            dashboard: 'Painel',
            'my-members': 'Meus membros',
            'my-sessions': 'Minhas sessões',
            'members-added': 'Membros adicionados',
            'members-removed': 'Membros removidos',
            skills: 'Habilidades',
            'skill-already-exist': 'Habilidade já existente',
            'add-skill': 'Adicionar habilidade',
            'skill-edited': 'Habilidade editada',
            'skill-deleted': 'Habilidade deletada',
            '4-players-with-most-missings': '4 jogadores com mais faltas',
            'skills-least-mastered': 'Habilidades menos dominadas',
            noGroupsWithMembers: 'Nenhum grupo com membros encontrado',
            noPlayersWithMissings: 'Nenhum jogador com faltas neste grupo',
            noSkillsToDisplay: 'Nenhuma habilidade para exibir para este grupo',
            trainingSessionGroups: {
                title: 'Grupos de Sessões de Treino',
                createTitle: 'Criar Grupo',
                editTitle: 'Editar Grupo',
                members: 'Membros',
                deleteSuccess: 'Grupo excluído com sucesso',
                deleteError: 'Ocorreu um erro ao excluir o grupo',
                createSuccess: 'Grupo criado com sucesso',
                createError: 'Ocorreu um erro ao criar o grupo',
                updateSuccess: 'Grupo atualizado com sucesso',
                updateError: 'Ocorreu um erro ao atualizar o grupo',
                form: {
                    title: 'Título',
                    description: 'Descrição',
                },
                filters: {
                    search: 'Pesquisar',
                    searchPlaceholder: 'Pesquisar um grupo...',
                },
                shareWithCoaches: 'Compartilhar com treinadores',
                shareWithCoachesHelp: 'Selecione os treinadores com quem compartilhar este grupo de sessões',
            },
            exercises: {
                title: 'Exercícios',
                addExercise: 'Adicionar um exercício',
                searchPlaceholder: 'Pesquisar um exercício...',
                filters: {
                    intensity: 'Intensidade',
                    gameType: 'Tipo de jogo',
                    courtType: 'Tipo de quadra',
                    peopleCount: 'Número de pessoas',
                    skills: 'Habilidades',
                    all: 'Todas',
                    gameTypeSingles: 'Simples',
                    gameTypeDoubles: 'Duplas',
                    gameTypeBoth: 'Ambos',
                    courtTypeFull: 'Completa',
                    courtTypeHalf: 'Meia quadra',
                    courtTypeBoth: 'Ambos',
                },
                exerciseItem: {
                    people: 'pessoa',
                    courtTypeEnum: {
                        FULL: 'Completo',
                        HALF: 'Meia quadra',
                        BOTH: 'Ambos',
                    },
                },
                createSuccess: 'O exercício foi criado com sucesso',
                createError: 'Ocorreu um erro ao criar o exercício',
                updateSuccess: 'O exercício foi atualizado com sucesso',
                updateError: 'Ocorreu um erro ao atualizar o exercício',
                deleteSuccess: 'O exercício foi excluído com sucesso',
                deleteError: 'Ocorreu um erro ao excluir o exercício',
                deleting: 'Excluindo...',
                exercise: 'um exercício',
                description: 'Descrição',
                peopleCount: 'Número de pessoas',
                intensity: 'Intensidade',
                intensityLow: 'Baixa',
                intensityMedium: 'Média',
                intensityHigh: 'Alta',
                gameType: 'Tipo de jogo',
                gameTypeSingles: 'Simples',
                gameTypeDoubles: 'Duplas',
                gameTypeBoth: 'Ambos',
                courtType: 'Tipo de quadra',
                courtTypeFull: 'Completa',
                courtTypeHalf: 'Meia quadra',
                courtTypeBoth: 'Ambos',
                skills: 'Habilidades',
                generatedFrom: 'Gerado de',
                generateSuccess: 'O exercício foi gerado e associado com sucesso',
                generateError: 'Ocorreu um erro ao gerar o exercício',
            },
            parentSkills: 'Categorias de Habilidades',
            'skill-create-error': 'Ocorreu um erro ao criar a categoria',
            'skill-edit-error': 'Ocorreu um erro ao atualizar a categoria',
            'skill-delete-error': 'Ocorreu um erro ao excluir a categoria',
            'skill-created': 'Categoria criada com sucesso',
            'skill-updated': 'Categoria atualizada com sucesso',
        },
        member: {
            dashboard: 'Painel',
            'my-followed-skills': 'Minhas habilidades seguidas',
            'my-progression': 'Minha progressão',
            'my-skills': 'Minhas habilidades',
            documentation: 'Documentação',
            'search-document-input': '🔍 Pesquisar um documento',
            'search-skill-input': '🔍 Pesquisar uma habilidade',
            'satisfaction-survey': 'Pesquisa de Satisfação',
            'satisfaction-survey-iframe-fallback': 'A pesquisa de satisfação não pode ser exibida. Por favor, clique neste link para acessá-la.',
            'notify-skill-changes': 'Receber notificações por e-mail quando minhas habilidades forem atualizadas',
            'notification-preference-updated': 'Preferência de notificação atualizada com sucesso',
            'welcome-1': 'Oi {{ user.firstname }} {{ user.lastname }},',
            'welcome-2': 'Bem-vindo à sua conta BVA',
            'welcome-4': 'No futuro, novas ferramentas serão adicionadas',
            'edit-password': 'Alterar minha senha',
            'welcome-5':
                'Se você tem qualquer sugestão para melhoria do site nos contacte por email: president@bva-club.fr.',
            'last-news': 'Últimas notícias',
            'change-password-title': 'Mudar senha',
            'current-password-label': 'Senha atual',
            'new-password-label': 'Nova senha',
            'confirm-password-label': 'Confirme nova senha',
        },
        error: {
            'session-expired': 'Sua sessão expirou, você está sendo desconectado por motivos de segurança.',
        },
        page: {
            planning: {
                joyride: {
                    body: {
                        title: 'Horários e Preços',
                        content: 'Um pequeno tour guiado para ajudá-lo a encontrar seu caminho e não perder nada!',
                    },
                    'help-btn': {
                        title: 'Botão Guie-me',
                        content: 'Este botão reinicia o tour guiado.',
                    },
                    'planning-holidays': {
                        title: 'Calendário de Férias Escolares',
                        content: 'Este calendário corresponde às sessões disponíveis durante as férias escolares.',
                    },
                    'planning-summer': {
                        title: 'Calendário de Férias de Verão',
                        content: 'Este calendário corresponde às sessões disponíveis durante as férias de verão.',
                    },
                    legend: {
                        title: 'A Legenda',
                        content: 'Cada calendário contém uma legenda que o ajudará a entender melhor o calendário.',
                    },
                    planning: {
                        title: 'Calendário Principal',
                        content: 'Este calendário corresponde às sessões principais que ocorrerão durante todo o ano.',
                    },
                    try: {
                        title: 'Sessões de julgamento',
                        content: 'Se você for um novato, isso deve lhe interessar!',
                    },
                    'our-prices': {
                        title: 'Nossas licenças',
                        content:
                            'Depois de ter feito pelo menos uma sessão de teste, você pode nos solicitar o formulário de registro. Nesse formulário, você pode escolher a licença que mais lhe convém e o método de pagamento de sua preferência.',
                    },
                },
                'summer-sessions':
                    'As sessões de verão são abertas a todos durante as férias de verão. É um bom momento para vir e experimentar e se divertir conosco nas quadras.',
            },
            contact: {
                title: 'Fale conosco',
            },
            price: {
                title: 'Preços para a temporada {{season}}',
                'title-try': 'Sessões Experimentais',
                'price-try-1':
                    "Você precisa entrar em contato com o clube por e-mail ou telefone, você pode encontrá-los na página <a href='{{contactLink}}'>Contate-nos</a>.",
                'price-try-2': 'Nós podemos emprestar raquetes e petecas para as sessões experimentais.',
                'price-try-3': 'Após isso, você deve trazer sua própria raquete e petecas.',
                'register-info-date':
                    'As inscrições serão abertas em 1º de agosto para renovações de membros existentes. E a partir de 2 de setembro {{registrationYear}} para novos membros.',
                'register-info-competition': 'Todas as nossas licenças permitem que você participe de competições.',
                'warning-off-day': '⚠️ Observe: O clube está sempre fechado nos feriados ! ⚠️',
            },
            competition: {
                title: 'Torneios',
                'badnet-register': 'Se inscreva no BadNet',
                'tournament-account-register': 'Se inscreva com a sua conta de torneios',
                'need-login': 'Para usar a sua conta de torneios, você precisa se conectar',
                'no-data': 'Nenhum torneio ainda. Nós vamos adicioná-los em breve.',
            },
            login: {
                connexion: 'Login',
                member: 'Membro',
                coach: 'Coach',
                admin: 'Administrador',
                'go-to-member-space': 'Ir para o espaço do membro',
                'go-to-coach-space': 'Ir para o espaço do coach',
                'go-to-admin-space': 'Ir para o espaço do administrador',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'connection-success': 'Conectado com sucesso !',
                'send-email': 'Enviar email',
                'pseudo-placeholder': 'Seu nome de usuário',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                'email-or-pseudo': 'Email ou nome de usuário',
                password: 'Senha',
                connect: 'Entrar',
            },
        },
        joyride: {
            help: 'Me guie !',
            next: 'Próximo',
            last: 'Finalizar Tour',
            skip: 'Fechar',
            back: 'Anterior',
            close: 'Fechar',
        },
        bot: {
            init: 'Oi, como posso te ajudar? Faça uma pergunta curta e use palavras-chave. Por examplo, a palavra "preço" irá te redirecionar para a página com informações sobre valores. Para mensagens longas, nos contacte através do email : contact@bva-club.fr',
        },
        cookies: 'Este site utiliza cookies que dura apenas 24h para medir o número de visitas.',
        skill: { TO_DISCOVER: 'Descobrir', STARTED: 'Iniciado', CONFIRMED: 'Confirmado', MASTERED: 'Masterizado' },
    }
}

export default ptTranslation
